import { FormControl, FormLabel, FormHelperText } from "@chakra-ui/react";
import Select from "react-select";
import { FiAlertCircle } from "react-icons/fi";

const AutoComplete = ({
    data = [],
    label = '',
    onChange,
    extra,
    disabled = false,
    value,
    required = false,
    labelProp = 'name',
    valueProp = '_id',
    helperText = '',
}) => {
    const options = data.map(item => ({
        label: item[labelProp],
        value: item[valueProp],
        fullItem: item,
    }));

    const selectedOption = options.find(opt => opt.value === value) || null;

    const handleChange = (selected) => {
        onChange(selected?.value);
    };

    return (
        <div className={`relative ${extra}`}>
            <FormControl isRequired={required}>
                <FormLabel hidden={label ? false : true} className="!text-sm !text-navy-700 dark:!text-white !font-bold">
                    {label}
                </FormLabel>
                <Select
                    options={options}
                    value={selectedOption}
                    onChange={handleChange}
                    isDisabled={disabled}
                    placeholder="Seleccionar..."
                    menuPosition="fixed"
                    noOptionsMessage={() => (
                        <div className="text-red-500 dark:text-red-400 p-3 flex items-center">
                            <FiAlertCircle size={20} className="mr-2" />
                            ¡Datos no encontrados!
                        </div>
                    )}
                    classNames={{
                        control: ({ isFocused, isDisabled }) => `
      flex items-center !rounded !border-[2.5px] px-1 py-1 !min-h-[42px] !text-sm
      transition-all duration-200 ease-in-out ${isDisabled ? `!opacity-50 !bg-gray-50 dark:!bg-navy-700
            !border-gray-300 dark:!border-navy-700
            !text-gray-800 dark:!text-gray-400 !cursor-not-allowed !shadow-none
            `
                                : `
            !bg-lightPrimary dark:!bg-navy-900
            text-gray-800 dark:text-white
            !border-gray-300 dark:!border-white/10
            hover:!border-brand-500 dark:hover:!border-brand-400
            focus-within:!ring-[1px] focus-within:!ring-brand-500 focus-within:!border-brand-500
            ring-offset-0 ring-offset-transparent
            ${isFocused ? '!ring-[1px] !ring-brand-500 !border-brand-500 shadow-sm' : ''}
            focus:outline-none
          `
                            }
    `,
                        menu: () => `
      mt-1 rounded-xl shadow-lg bg-white dark:bg-navy-900 !z-40
    `,
                        option: ({ isFocused, isSelected, isDisabled }) => `
      cursor-pointer px-3 py-2 text-sm
      ${isDisabled
                                ? '!text-gray-800 dark:!text-gray-400 !cursor-not-allowed'
                                : isSelected
                                    ? '!bg-brand-500 dark:!bg-brand-400 text-brand-700'
                                    : isFocused
                                        ? '!bg-brand-500 dark:!bg-brand-400 !text-white dark:!text-white'
                                        : '!text-gray-950 dark:!text-white'
                            }
    `,
                        singleValue: ({ isDisabled }) => `
      ${isDisabled ? '!text-gray-800 dark:!text-gray-400' : '!text-gray-800 dark:!text-white'}
    `,
                        input: () => `
      text-sm text-gray-700 dark:text-white
    `,
                        placeholder: () => `
      text-gray-400 dark:text-gray-500
    `,
                        dropdownIndicator: ({ isDisabled }) => `
      ${isDisabled ? '!text-gray-800 dark:!text-gray-400 !cursor-not-allowed' : '!text-gray-500 dark:!text-white'}
    `,
                    }}
                />

                {helperText && (
                    <FormHelperText className="mt-1 text-brand-500 dark:text-brand-200 opacity-80">
                        {helperText}
                    </FormHelperText>
                )}
            </FormControl>
        </div>
    );
};

export default AutoComplete;
